export default "/assets/website/images/arrow-down.svg?f0160bb4c817adfecc4fd2ddad525c2d";